/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies
 */
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */

export default function save( props ) {
	const {
		attributes: { contentJustification, orientation },
	} = props;
	return (
		<div
			{ ...useBlockProps.save( {
				className: classnames( {
					[ `is-content-justification-${ contentJustification }` ]: contentJustification,
					'is-vertical': orientation === 'vertical',
				}, 'wp-block-buttons' ),
			} ) }
		>
			<InnerBlocks.Content />
		</div>
	);
}
